export const DOC_REQUEST = 'DOC_REQUEST'
export const DOC_SUCCESS = 'DOC_SUCCESS'
export const DOC_FAILURE = 'DOC_FAILURE'